module.exports = __webpack_public_path__ + "assets/location-962a61.svg";